
import * as React from 'react';
import InformationAlert from '../../../infrastructure/InformationAlert';

const BidViewInformation = () => (
  <InformationAlert text="Your current bids" />
);

export default BidViewInformation;